import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deskPath, waitForPrintWindow } from '../utils/printWindow';

// Some browsers (iPad) never report that the print dialog closed, so the progress screen gives up.
export const MAX_PRINT_PROGRESS_MS = 20000;

/** Desk flow: after a badge print starts, optionally show "printing in progress", then go back to the desk. */
export default function useDeskPrintReturn({ fromDesk, eventId, showProgress = true }) {
  const navigate = useNavigate();
  const [isPrintingBadge, setIsPrintingBadge] = useState(false);
  const returnedRef = useRef(false);

  const backToDesk = useCallback(() => {
    if (returnedRef.current) return;
    returnedRef.current = true;
    setIsPrintingBadge(false);
    navigate(deskPath(eventId));
  }, [navigate, eventId]);

  const handleBadgePrintStarted = useCallback(async (printWindow) => {
    if (!fromDesk) return;
    returnedRef.current = false;
    if (!showProgress) {
      backToDesk();
      return;
    }
    setIsPrintingBadge(true);
    await waitForPrintWindow(printWindow, { maxWaitMs: MAX_PRINT_PROGRESS_MS });
    backToDesk();
  }, [fromDesk, showProgress, backToDesk]);

  return { isPrintingBadge, handleBadgePrintStarted, backToDesk };
}
